<template>
  <div class="home">
    <SplashModal></SplashModal>
    <Menu />
    <Navigation/>
    <Room/>
    <Loader/>
  </div>
</template>

<script>
// @ is an alias to /src
import SplashModal from '@/components/SplashModal.vue';
import Menu from '@/components/Menu.vue';
import Navigation from '@/components/Navigation.vue';
import Room from '@/components/Room';
// import Gallery from '@/components/Gallery.vue';
import Loader from '@/components/Loader.vue';

export default {
  name: "Home",
  components: {
    SplashModal,
    Menu,
    Navigation,
    Room,
    // Gallery,
    Loader
  },

  methods : {

  }
};
</script>
